import { createContext, useContext } from 'react';
import { gql, TypedDocumentNode, useQuery } from '@apollo/client';

import { useAppSelector } from 'app/store';
import { selectUserInfo } from 'app/store/user';

export type DevConsoleFlags = {
  teamTabEnabled: boolean;
  viewCreateOrder: boolean;
  ryeAdminAccount: boolean;
  requireEmailVerification: boolean;
};

const DEFAULT_FLAGS: DevConsoleFlags = {
  teamTabEnabled: false,
  viewCreateOrder: false,
  ryeAdminAccount: false,
  requireEmailVerification: false,
};

const DEV_CONSOLE_FLAGS: TypedDocumentNode<
  { devConsoleFlags: DevConsoleFlags },
  Record<string, never>
> = gql`
  query devConsoleFlags {
    devConsoleFlags {
      teamTabEnabled
      viewCreateOrder
      ryeAdminAccount
      requireEmailVerification
    }
  }
`;

const FlagsContext = createContext<DevConsoleFlags>(DEFAULT_FLAGS);

export function FlagsProvider({ children }: { children: React.ReactNode }) {
  const adminToken = useAppSelector(selectUserInfo)?.adminToken;
  const { data } = useQuery(DEV_CONSOLE_FLAGS, {
    skip: !adminToken,
    context: { clientName: 'admin' },
  });

  return (
    <FlagsContext.Provider value={data?.devConsoleFlags ?? DEFAULT_FLAGS}>
      {children}
    </FlagsContext.Provider>
  );
}

export function useFlags(): DevConsoleFlags {
  return useContext(FlagsContext);
}
